import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { CircularProgress } from "@mui/material";

export default function FullPageModal(props) {
  return (
    <div>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
      >
        <Box
          height={"100vh"}
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress alignItems="center" justifyContent="center" />
          {props.children}
        </Box>
      </Modal>
    </div>
  );
}
